import React, { useState } from 'react';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import { useTeamPageContext } from '../../../TeamPage';
import { modalType } from '../../../OpenedModalType';
import { teamPageReducerTypes } from '../../../Reducer';
import MenuList from '../../../../../Elements/MenuList';
import MenuListItem from '../../../../../Elements/MenuListItem';
import ThreeDotIcon from '../../../../../Elements/ids/ThreeDotIcon';

const ActiveAgentMenu = ({ agent, areBrokerFunctionsAvailable }) => {
  const { teamPageDispatch } = useTeamPageContext();
  const [isOpen, setIsOpen] = useState(false);

  const dispatchSetOpenedModal = (modalType, agent) => {
    teamPageDispatch({
      type: teamPageReducerTypes.setOpenedModal,
      payload: {
        modalType: modalType,
        modalAgent: agent,
      },
    });
    setIsOpen(false);
  };

  return (
    <div style={{ position: 'relative' }}>
      <ThreeDotIcon
        onClick={() => {
          setIsOpen(true);
        }}
      />

      <MenuList
        isOpen={isOpen}
        onOutsideClick={() => {
          setIsOpen(false);
        }}>
        <MenuListItem
          text={formatMessage(Messages.common_edit)}
          onClick={() => {
            dispatchSetOpenedModal(modalType.AgentInfo, agent);
          }}
        />
        {areBrokerFunctionsAvailable && (
          <MenuListItem
            text={formatMessage(Messages.headerMenu_editBankAccount)}
            onClick={() => {
              dispatchSetOpenedModal(modalType.BankAccount, agent);
            }}
          />
        )}
        {areBrokerFunctionsAvailable && (
          <MenuListItem
            text={formatMessage(Messages.headerMenu_viewBankLog)}
            onClick={() => {
              dispatchSetOpenedModal(modalType.BankLog, agent);
            }}
          />
        )}
        {areBrokerFunctionsAvailable && (
          <MenuListItem
            text={formatMessage(Messages.headerMenu_commissionPage)}
            onClick={() => {
              dispatchSetOpenedModal(modalType.Commission, agent);
            }}
          />
        )}
        <MenuListItem
          text={formatMessage(Messages.headerMenu_revokeAgent)}
          onClick={() => {
            dispatchSetOpenedModal(modalType.Revoke, agent);
          }}
        />
        <MenuListItem
          text={formatMessage(Messages.headerMenu_editAddress)}
          onClick={() => {
            dispatchSetOpenedModal(modalType.AddressInfo, agent);
          }}
        />
        <MenuListItem
          text={formatMessage(Messages.headerMenu_viewAddressLog)}
          onClick={() => {
            dispatchSetOpenedModal(modalType.AddressLog, agent);
          }}
        />
        <MenuListItem
          text={formatMessage(Messages.headerMenu_setDefaultAgent)}
          onClick={() => {
            dispatchSetOpenedModal(modalType.DefaultAgent, agent);
          }}
          disabled={agent.isDefaultAgentCode}
        />
      </MenuList>
    </div>
  );
};

export default ActiveAgentMenu;
